// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__HDrbX","menuIcon":"Hamburger_menuIcon__QnSup"};